import '@babel/polyfill';
import 'what-input';
import objectFitImages from 'object-fit-images';
import svg4everybody from 'svg4everybody';
import focusWithin from 'focus-within';

import './modernizr';
import './modules';

objectFitImages();
svg4everybody();
focusWithin(document);
